var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlandingGa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 67,
    viewBox: "0 0 61 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1557 10.3005L45.87 50.2866C47.0698 54.7643 50.8229 56.427 54.0983 55.5494C57.1276 54.7377 59.8916 51.7244 58.5929 46.8776L47.9598 7.19429C46.8614 3.09534 43.1448 1.34163 39.8126 2.23448C36.4804 3.12734 34.2096 6.76948 35.1557 10.3005Z",
    fill: "#F8AB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9331 35.0607L29.209 54.7509C30.4088 59.2285 34.162 60.8913 37.4373 60.0137C40.4666 59.202 43.2306 56.1886 41.9319 51.3418L36.7371 31.9546C35.6388 27.8556 31.9221 26.1019 28.59 26.9948C25.2578 27.8876 22.9869 31.5298 23.9331 35.0607Z",
    fill: "#E37300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4333 56.412C26.3743 59.924 24.2884 63.5369 20.7764 64.4779C17.2643 65.419 13.6515 63.3331 12.7104 59.821C11.7694 56.309 13.8553 52.6961 17.3673 51.7551C20.8793 50.814 24.4922 52.8999 25.4333 56.412Z",
    fill: "#E37300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlandingGa);
export default __webpack_public_path__ + "static/media/slandingGa.726bed8b445ea37868071e97edf068a8.svg";
export { ForwardRef as ReactComponent };